export const actions = {
    GET_HOME_PAGE_ITEMS: 'GET_HOME_PAGE_ITEMS',
    GET_HOME_PAGE_ITEMS_SUCCESS: 'GET_HOME_PAGE_ITEMS_SUCCESS',
    GET_HOME_PAGE_ITEMS_FAILED_DONE: 'GET_HOME_PAGE_ITEMS_FAILED_DONE',
    REMOVE_HOME_PAGE_ITEMS: 'REMOVE_HOME_PAGE_ITEMS',
    GET_SUB_CATEGORIES: 'GET_SUB_CATEGORIES',
    SUB_CATEGORIES_SUCCESS: 'FETCH_SUB_CATEGORIES_SUCCESS',
    SUB_CATEGORIES_FAILED: 'FETCH_SUB_CATEGORIES_FAILED',
    GET_CATEGORY_FILTERS: 'GET_CATEGORY_FILTERS',
    GET_CATEGORY_FILTERS_SUCCESS: 'GET_CATEGORY_FILTERS_SUCCESS',
    GET_CATERING_FILTERS: 'GET_CATERING_FILTERS',
    GET_CATERING_FILTERS_SUCCESS: 'GET_CATERING_FILTERS_SUCCESS',
    REMOVE_CATEGORY_FILTERS: 'REMOVE_CATEGORY_FILTERS',
    REMOVE_CATERING_FILTERS: 'REMOVE_CATERING_FILTERS',
    GET_SUB_CATEGORY_FILTERS: 'GET_SUB_CATEGORY_FILTERS',
    GET_SUB_CATEGORY_FILTERS_SUCCESS: 'GET_SUB_CATEGORY_FILTERS_SUCCESS',
    GET_SUB_CATERING_FILTERS: 'GET_SUB_CATERING_FILTERS',
    GET_SUB_CATERING_FILTERS_SUCCESS: 'GET_SUB_CATERING_FILTERS_SUCCESS',
    REMOVE_SUB_CATEGORY_FILTERS: 'REMOVE_SUB_CATEGORY_FILTERS',
    REMOVE_SUB_CATERING_FILTERS: 'REMOVE_SUB_CATERING_FILTERS',
    FILTERS_FAILED: 'FILTERS_FAILED',
    APPLY_CATEGORY_FILTERS: 'APPLY_CATEGORY_FILTERS',
    APPLY_CATEGORY_FILTERS_SUCCESS: 'APPLY_CATEGORY_FILTERS_SUCCESS',
    APPLY_CATERING_FILTERS: 'APPLY_CATERING_FILTERS',
    APPLY_CATERING_FILTERS_SUCCESS: 'APPLY_CATERING_FILTERS_SUCCESS',
    REMOVE_APPLIED_CATEGORY_FILTERS: 'REMOVE_APPLIED_CATEGORY_FILTERS',
    REMOVE_APPLIED_CATERING_FILTERS: 'REMOVE_APPLIED_CATERING_FILTERS',
    APPLY_SUB_CATEGORY_FILTERS: 'APPLY_SUB_CATEGORY_FILTERS',
    APPLY_SUB_CATEGORY_FILTERS_SUCCESS: 'APPLY_SUB_CATEGORY_FILTERS_SUCCESS',
    APPLY_SUB_CATERING_FILTERS: 'APPLY_SUB_CATERING_FILTERS',
    APPLY_SUB_CATERING_FILTERS_SUCCESS: 'APPLY_SUB_CATERING_FILTERS_SUCCESS',
    REMOVE_APPLIED_SUB_CATEGORY_FILTERS: 'REMOVE_APPLIED_SUB_CATEGORY_FILTERS',
    REMOVE_APPLIED_SUB_CATERING_FILTERS: 'REMOVE_APPLIED_SUB_CATERING_FILTERS',
    GET_PRODUCT_DETAILS: 'GET_PRODUCT_DETAILS',
    GET_PRODUCT_DETAILS_SUCCESS: 'GET_PRODUCT_DETAILS_SUCCESS',
    GET_PRODUCT_DETAILS_FAILED: 'GET_PRODUCT_DETAILS_FAILED',
    GET_PRODUCT_DETAILS_BY_ID: 'GET_PRODUCT_DETAILS_BY_ID',
    GET_PRODUCT_DETAILS_BY_ID_SUCCESS: 'GET_PRODUCT_DETAILS_BY_ID_SUCCESS',
    GET_PRODUCT_DETAILS_BY_ID_FAILED: 'GET_PRODUCT_DETAILS_BY_ID_FAILED',
    SEARCH_PRODUCTS: 'SEARCH_PRODUCTS',
    SEARCH_PRODUCTS_SUCCESS: 'SEARCH_PRODUCTS_SUCCESS',
    SEARCH_PRODUCTS_FAILED: 'SEARCH_PRODUCTS_FAILED',
    SET_SEARCHED_VALUE: 'SET_SEARCHED_VALUE',
    GET_SEARCHED_PRODUCT: 'GET_SEARCHED_PRODUCT',
    GET_SEARCHED_PRODUCT_SUCCESS: 'GET_SEARCHED_PRODUCT_SUCCESS',
    GET_SEARCHED_PRODUCT_FAILED: 'GET_SEARCHED_PRODUCT_FAILED',
    LOAD_PRODUCTS: 'LOAD_PRODUCTS',
    LOAD_PRODUCTS_SUCCESS: 'LOAD_PRODUCTS_SUCCESS',
    LOAD_PRODUCTS_FAILED: 'LOAD_PRODUCTS_FAILED',
    SET_LAST_HOME_PAGE_FETCH: 'SET_LAST_HOME_PAGE_FETCH',
    RESET_SEARCH_PRODUCTS: 'RESET_SEARCH_PRODUCTS',
    CLEAR_PRODUCTS: 'CLEAR_PRODUCTS',
    SET_SELECTED_SUB_CATEGORY: 'SET_SELECTED_SUB_CATEGORY',
    DETAILS_PAGE_LOADING: 'DETAILS_PAGE_LOADING',
    SET_LOCALIZED_PRODUCT_SUB_CATEGORY_NAME: 'SET_LOCALIZED_PRODUCT_SUB_CATEGORY_NAME',
    GET_STORE_ADDRESS: 'GET_STORE_ADDRESS',
    GET_STORE_ADDRESS_SUCCESS: 'GET_STORE_ADDRESS_SUCCESS',
    GET_STORE_ADDRESS_FAILED: 'GET_STORE_ADDRESS_FAILED',
    GET_HOME_PAGE_CATEGORIES_LIST: 'GET_HOME_PAGE_CATEGORIES_ITEMS',
    GET_HOME_PAGE_CATEGORIES_ITEMS_SUCCESS: 'GET_HOME_PAGE_CATEGORIES_ITEMS_SUCCESS',
    GET_HOME_PAGE_CATEGORIES_ITEMS_FAILED_DONE: 'GET_HOME_PAGE_CATEGORIES_ITEMS_FAILED_DONE',
    SET_CATERING_SCHEDULE: 'SET_CATERING_SCHEDULE',
    CLEAR_CATERING_SCHEDULE: 'CLEAR_CATERING_SCHEDULE',
}

export const getHomePageItems = () => ({
    type: actions.GET_HOME_PAGE_ITEMS,
})

export const getHomePageItemsSuccess = items => ({
    type: actions.GET_HOME_PAGE_ITEMS_SUCCESS,
    payload: items,
})

export const getHomePageItemsFailedDone = () => ({
    type: actions.GET_HOME_PAGE_ITEMS_FAILED_DONE,
})

export const getStoreAddress = () => ({
    type: actions.GET_STORE_ADDRESS,
})

export const getStoreAddressSuccess = payload => ({
    type: actions.GET_STORE_ADDRESS_SUCCESS,
    payload,
})

export const getStoreAddressFailed = () => ({
    type: actions.GET_STORE_ADDRESS_FAILED,
})

export const setLastHomePageFetchETA = time => ({
    type: actions.SET_LAST_HOME_PAGE_FETCH,
    payload: time,
})

export const removeHomePageItems = () => ({
    type: actions.REMOVE_HOME_PAGE_ITEMS,
})
export const getSubCategories = payload => ({
    type: actions.GET_SUB_CATEGORIES,
    payload,
})

export const subCategoriesSuccess = (items, transformedPayload) => ({
    type: actions.SUB_CATEGORIES_SUCCESS,
    payload: items,
    transformedPayload,
})

export const subCategoriesFailed = () => ({
    type: actions.SUB_CATEGORIES_FAILED,
})

export const getCategoryFilters = payload => ({
    type: actions.GET_CATEGORY_FILTERS,
    payload,
})

export const getCategoryFiltersSuccess = payload => ({
    type: actions.GET_CATEGORY_FILTERS_SUCCESS,
    payload,
})

export const getCateringFilters = payload => ({
    type: actions.GET_CATERING_FILTERS,
    payload,
})

export const getCateringFiltersSuccess = payload => ({
    type: actions.GET_CATERING_FILTERS_SUCCESS,
    payload,
})

export const removeCategoryFilters = () => ({
    type: actions.REMOVE_CATEGORY_FILTERS,
})

export const removeCateringFilters = () => ({
    type: actions.REMOVE_CATERING_FILTERS,
})

export const filterErrors = () => ({
    type: actions.FILTERS_FAILED,
})

export const applyCategoryFilters = payload => ({
    type: actions.APPLY_CATEGORY_FILTERS,
    payload,
})

export const applyCategoryFiltersSuccess = payload => ({
    type: actions.APPLY_CATEGORY_FILTERS_SUCCESS,
    payload,
})

export const applyCateringFilters = payload => ({
    type: actions.APPLY_CATERING_FILTERS,
    payload,
})

export const applyCateringFiltersSuccess = payload => ({
    type: actions.APPLY_CATERING_FILTERS_SUCCESS,
    payload,
})

export const removeAppliedCategoryFilters = () => ({
    type: actions.REMOVE_APPLIED_CATEGORY_FILTERS,
})

export const removeAppliedCateringFilters = () => ({
    type: actions.REMOVE_APPLIED_CATERING_FILTERS,
})

export const getSubCategoryFilters = payload => ({
    type: actions.GET_SUB_CATEGORY_FILTERS,
    payload,
})

export const getSubCategoryFiltersSuccess = payload => ({
    type: actions.GET_SUB_CATEGORY_FILTERS_SUCCESS,
    payload,
})

export const getSubCateringFilters = payload => ({
    type: actions.GET_SUB_CATERING_FILTERS,
    payload,
})

export const getSubCateringFiltersSuccess = payload => ({
    type: actions.GET_SUB_CATERING_FILTERS_SUCCESS,
    payload,
})

export const removeSubCategoryFilters = () => ({
    type: actions.REMOVE_SUB_CATEGORY_FILTERS,
})

export const removeSubCateringFilters = () => ({
    type: actions.REMOVE_SUB_CATERING_FILTERS,
})

export const applySubCategoryFilters = payload => ({
    type: actions.APPLY_SUB_CATEGORY_FILTERS,
    payload,
})

export const applySubCategoryFiltersSuccess = payload => ({
    type: actions.APPLY_SUB_CATEGORY_FILTERS_SUCCESS,
    payload,
})

export const applySubCateringFilters = payload => ({
    type: actions.APPLY_SUB_CATERING_FILTERS,
    payload,
})

export const applySubCateringFiltersSuccess = payload => ({
    type: actions.APPLY_SUB_CATERING_FILTERS_SUCCESS,
    payload,
})

export const removeAppliedSubCategoryFilters = () => ({
    type: actions.REMOVE_APPLIED_SUB_CATEGORY_FILTERS,
})

export const removeAppliedSubCateringFilters = () => ({
    type: actions.REMOVE_APPLIED_SUB_CATERING_FILTERS,
})

export const getProductDetails = payload => ({
    type: actions.GET_PRODUCT_DETAILS,
    payload,
})

export const getProductDetailsSuccess = productDetails => ({
    type: actions.GET_PRODUCT_DETAILS_SUCCESS,
    payload: productDetails,
})

export const getProductDetailsFailed = error => ({
    type: actions.GET_PRODUCT_DETAILS_FAILED,
    payload: error,
})

export const getProductDetailsById = payload => ({
    type: actions.GET_PRODUCT_DETAILS_BY_ID,
    payload,
})

export const getProductDetailsByIdSuccess = response => ({
    type: actions.GET_PRODUCT_DETAILS_BY_ID_SUCCESS,
    payload: response,
})

export const getProductDetailsByIdFailed = error => ({
    type: actions.GET_PRODUCT_DETAILS_BY_ID_FAILED,
    payload: error,
})

export const searchProducts = request => ({
    type: actions.SEARCH_PRODUCTS,
    payload: request,
})

export const searchProductsSuccess = result => ({
    type: actions.SEARCH_PRODUCTS_SUCCESS,
    payload: result,
})
export const detailsPageLoad = result => ({
    type: actions.DETAILS_PAGE_LOADING,
    payload: result,
})

export const searchProductsFailed = error => ({
    type: actions.SEARCH_PRODUCTS_FAILED,
    payload: error,
})

export const setSearchedValue = searchTerm => ({
    type: actions.SET_SEARCHED_VALUE,
    payload: searchTerm,
})

export const loadProducts = request => ({
    type: actions.LOAD_PRODUCTS,
    payload: request,
})

export const loadProductsSuccess = result => ({
    type: actions.LOAD_PRODUCTS_SUCCESS,
    payload: result,
})

export const loadProductsFailed = error => ({
    type: actions.LOAD_PRODUCTS_FAILED,
    payload: error,
})

export const getSearchedProduct = productId => ({
    type: actions.GET_SEARCHED_PRODUCT,
    payload: productId,
})

export const getSearchedProductSuccess = product => ({
    type: actions.GET_SEARCHED_PRODUCT_SUCCESS,
    payload: product,
})

export const clearProducts = () => ({
    type: actions.CLEAR_PRODUCTS,
})

export const getSearchedProductFailed = () => ({
    type: actions.GET_SEARCHED_PRODUCT_FAILED,
})
export const resetSearchedProducts = () => ({
    type: actions.RESET_SEARCH_PRODUCTS,
})

export const setSelectedSubCategory = name => ({
    type: actions.SET_SELECTED_SUB_CATEGORY,
    payload: name,
})

export const setSelectedLocalizedSubCategory = payload => ({
    type: actions.SET_LOCALIZED_PRODUCT_SUB_CATEGORY_NAME,
    payload,
})

export const getHomePageCategoryList = () => ({
    type: actions.GET_HOME_PAGE_CATEGORIES_LIST,
})

export const getHomePageCategoryItemsSuccess = items => ({
    type: actions.GET_HOME_PAGE_CATEGORIES_ITEMS_SUCCESS,
    payload: items,
})

export const getHomePageCategoryItemsFailedDone = () => ({
    type: actions.GET_HOME_PAGE_CATEGORIES_ITEMS_FAILED_DONE,
})

export const setCateringSchedule = (schedule) => ({
    type: actions.SET_CATERING_SCHEDULE,
    payload: schedule,
})

export const clearCateringSchedule = () => ({
    type: actions.CLEAR_CATERING_SCHEDULE,
})
